import { Root, ToggleProps } from '@radix-ui/react-toggle';

import type { ComponentPropsWithoutRef, FC } from 'react';

interface ToggleBadgeProps extends ComponentPropsWithoutRef<'button'>, ToggleProps {
  /**
   * Represents the label text to be displayed in the Badge component.
   */
  label: string;
}

const ToggleBadge: FC<ToggleBadgeProps> = ({ label, ...props }) => (
  <Root
    className="w-fit rounded-sm border border-primary-1000 bg-transparent px-3 py-1 font-spaceGrotesk text-sm font-medium text-primary-900 transition-colors focus-outline-tealCustom hover:border-primary-1100 data-[state=on]:bg-primary-1100 data-[state=on]:text-white"
    aria-label={label || 'toggle badge'}
    {...props}
  >
    {label}
  </Root>
);

export default ToggleBadge;
